import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LogsDataSource, AlertHttpService } from '../../../../../app/core/alerts';
import { MatPaginator, MatSort } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { MixpanelService } from '../../../../services/mixpanel.service'; // Import MixpanelService

@Component({
  selector: 'kt-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit, AfterViewInit {

	displayedColumns = ['time_stamp', 'log_desc'];

	dataSource: LogsDataSource;

	qParams: any;

	logCodes;

	searchForm: FormGroup;

	errOpt: any[] = [];

	wrnOpt: any[] = [];

	opts: any[] = [];

	selectedMachine: any;

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	constructor(private http: AlertHttpService, private mixpanel: MixpanelService, private route: ActivatedRoute, private machineRouteService: MachineRouteService) { }

  ngOnInit() {
	this.selectedMachine = this.machineRouteService.getMachine(this.route);
	if (!this.selectedMachine) return;
	this.dataSource = new LogsDataSource(this.http);
	this.searchForm = new FormGroup({
		logDesc: new FormControl(null),
		startDate: new FormControl(new Date(), [Validators.required]),
		endDate: new FormControl(new Date(), [Validators.required])
	});
	this.getLogCodes();
	this.qParams = {
		noPerPg: this.paginator.pageSize || 10,
		pgNo: this.paginator.pageIndex || 0,
		machine_id: this.selectedMachine.machine_id,
		sortKey: 'time_stamp',
		sortVal: 'desc',
		optFilterKey: 'log_type',
		optFilterVal: `evt`,
		txtFilterKey: '',
		txtFilterVal: null,
		startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
		endDate: ''
	};

		this.mixpanel.track(this.mixpanel.PAGE_VIEW, {
machineId: this.selectedMachine.machine_id,
			machineName: this.selectedMachine.machine_name,
			machineSerialNo: this.selectedMachine.serial_no
		});
}

  ngAfterViewInit() {
	this.dataSource.counter$
	.pipe(
		tap((count) => {
			this.paginator.length = count;
		})
	)
	.subscribe();

	this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

	merge(this.paginator.page, this.sort.sortChange).pipe(
		tap(() => {
			// console.log(this.paginator.pageIndex);
			this.loadLogs();
		})
	).subscribe();

  }

  dateFormatUTC(date: Date, period: string) {
	let dateStr =
	`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${(date.getDate()).toString().padStart(2, '0')} `;
	if (period === 'start') {
		dateStr += '00:00:00';
	} else {
		dateStr += '23:59:59';
	}
	return new Date(dateStr.replace(/-/g, '/')).toISOString();
}

// typeChanged() {
// 	// console.log(this.searchForm.get('logType').value);
// 	this.opts = [];
// 	const typeSel = this.searchForm.get('logType').value;
// 	if (typeSel === 'all') {
// 		this.opts = this.errOpt.concat(this.wrnOpt);
// 	} else if (typeSel === 'err') {
// 		this.opts = this.errOpt;
// 	} else if (typeSel === 'wrn') {
// 		this.opts = this.wrnOpt;
// 	}
// }

  getLogCodes() {
	  this.http.getMacLogCodes()
	  .subscribe(logCodes => {
		this.logCodes = logCodes.processed;
		// console.log('Logcodes--' + this.logCodes);
		// this.segregateOptions(logCodes.raw);
		this.dataSource.loadLogsList(this.qParams);
	  });
  }

//   segregateOptions(opts: any) {
// 	for (let row of opts) {
// 		if (row.log_code.startsWith('e0')) {
// 			this.errOpt.push(row);
// 		} else if (row.log_code.startsWith('w0')) {
// 			this.wrnOpt.push(row);
// 		}
// 	}
// 	this.opts = this.errOpt.concat(this.wrnOpt);

//   }

  parseLogCodes(codeObj) {
	if (codeObj.occOrRes === 0 || codeObj.occOrRes === 1) {
		const content = this.logCodes[codeObj.occOrRes];
		if (content.hasOwnProperty([codeObj.log_code])) {
			if(codeObj.data_type){
				return content[codeObj.log_code] + this.parseActivityData(codeObj);
			}else{
				return content[codeObj.log_code]; // + ' (' + codeObj.log_desc + ', ' + codeObj.occOrRes + ')';
			}

		} else {
			return codeObj.log_code;
		}
	} else {
		return codeObj.log_code;
	}
  }

  parseActivityData(obj){
		let _data;
		// console.log("event obj", obj);

		if(obj.data_type){
			_data = JSON.parse(obj._data);
			if(obj.data_type == "RESTOCK"){
				return ` on ${_data.length} Item(s)`;
			}else if(obj.data_type == "MXRCLEAN"){
				return ` ${_data.mixer}`;
			}else{
				return '';
			}
		}else{
			return '';
		}
	}

  loadLogs() {

	this.qParams = {
		noPerPg: this.paginator.pageSize || 10,
		pgNo: this.paginator.pageIndex || 0,
		machine_id: this.selectedMachine.machine_id,
		sortKey: this.sort.active,
		sortVal: this.sort.direction,
		optFilterKey: 'log_type',
		optFilterVal: `evt`,
		txtFilterKey: 'log_code',
		txtFilterVal: this.searchForm.get('logDesc').value,
		startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
		endDate: this.dateFormatUTC(this.searchForm.get('endDate').value, 'end')
	};
	// console.log(this.qParams);
	this.dataSource.loadLogsList(this.qParams);
  }

  onSubmited() {
	this.paginator.pageIndex = 0;
	// console.log('Search Val', this.searchForm.get('logDesc').value);
	this.qParams = {
		noPerPg: this.paginator.pageSize || 10,
		pgNo: this.paginator.pageIndex || 0,
		machine_id: this.selectedMachine.machine_id,
		sortKey: this.sort.active,
		sortVal: this.sort.direction,
		optFilterKey: 'log_type',
		optFilterVal: `evt`,
		txtFilterKey: 'log_code',
		txtFilterVal: this.searchForm.get('logDesc').value,
		startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
		endDate: this.dateFormatUTC(this.searchForm.get('endDate').value, 'end')
	};

	// console.log(this.qParams);
	this.dataSource.loadLogsList(this.qParams);
  }

}
